const data = {
  properties: [
    {
      _id: '1',
      index: 0,
      picture: 'https://i.ibb.co/JFNqJLL/image.png',
      title: `COX'S BAZAR`,
      desc: `Cox's Bazar is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it...`,
      fullDesc: `Cox's Bazar is a town, a fishing port and district headquarters in Bangladesh. The beach in Cox's Bazar is an unbroken 125 km sandy sea beach with a gentle slope, one of the world's longest. Today, Cox's Bazar is one of the most-visited tourist destinations in Bangladesh, and now it has a international hotel chains. This place is better for local and foreign tourists, as well as to look after the nature and wildlife in the tourist spots of Cox's Bazar...`,
    },
    {
      _id: '2',
      index: 1,
      picture: 'https://i.ibb.co/xsrZnzR/Sreemongol.png',
      title: 'SREEMANGAL',
      desc: `Srimangal/Sreemangal is a city in Sylhet Division in Bangladesh. Sreemangal is situated in Moulvibazar district in sylhet division. Sreemangal is an Upazila. It is...`,
      fullDesc: `Srimangal/Sreemangal is a city in Sylhet Division in Bangladesh. Sreemangal is situated in Moulvibazar district in sylhet division. Sreemangal is an Upazila. It is famous for tea garden. Rain all time occurs here. Nature has adorned sreemangal with green tress. Its natural scenery is very charming. It soothes one’s eyes. Birds are twittering always here. The first tea garden in Bangladesh which names “Malni chho ra tea garden” is here...`,
    },
    {
      _id: '3',
      index: 2,
      picture: 'https://i.ibb.co/6btSR9B/sundorbon.png',
      title: 'SUNDARBAN',
      desc: `Sundarbans, formerly Sunderbunds, vast tract of forest and saltwater swamp forming the lower part of the Padma (Ganges [Ganga])-Brahmaputra River delta in southeastern...`,
      fullDesc: `Sundarbans, formerly Sunderbunds, vast tract of forest and saltwater swamp forming the lower part of the Padma (Ganges [Ganga])-Brahmaputra River delta in southeastern West Bengal state, northeastern India, and southern Bangladesh. The tract extends approximately 160 miles (260 km) west-east along the Bay of Bengal from the Hugli River estuary in India to the western segment of the Meghna River estuary in Bangladesh and reaches inland for about 50 miles (80 km) at its broadest point...`,
    },
  ],
};

export default data;
